/**
 * Socket.IO HTTP path. Must match backend SOCKET_IO_PATH.
 * Default `/api/socket.io` so Kubernetes/nginx ingress can route it with the same `/api` prefix as REST
 * (otherwise `/socket.io` hits the static frontend and the connection never reaches the API).
 */
export const CAMERA_SOCKET_PATH =
  (typeof process !== 'undefined' && process.env.REACT_APP_SOCKET_IO_PATH) || '/api/socket.io';
